$(function () {
  // $('a[href*=\\#]:not([href=\\#])').click(function() {
  // if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  // 		var $target = $(this.hash);
  // 		$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
  // 		if ($target.length) {
  // 			if($(this).parents('.menuBox').length){
  // 				setTimeout(function(){
  // 					var targetOffset = $target.offset().top;
  // 					$('html,body').animate({scrollTop: targetOffset}, 1000);
  // 				},100);
  // 			}else{
  // 				var targetOffset = $target.offset().top;
  // 				$('html,body').animate({scrollTop: targetOffset}, 1000);
  // 			}
  // 			return false;
  // 		}
  // 	}
  // });
  var state = false;
  var scrollpos;
  $(".menu").on("click", function () {
    if (state == false) {
      scrollpos = $(window).scrollTop();
      $("body").addClass("fixed").css({ top: -scrollpos });
      $(".menu").addClass("on");
      $(".menuBox").stop().addClass("on");
      state = true;
    } else {
      $("body").removeClass("fixed").css({ top: 0 });
      window.scrollTo(0, scrollpos);
      $(".menu").removeClass("on");
      $(".menuBox").stop().removeClass("on");
      state = false;
    }
  });

  $(".menu-close").on("click", function () {
    $("body").removeClass("fixed").css({ top: 0 });
    window.scrollTo(0, scrollpos);
    $(".menu").removeClass("on");
    $(".menuBox").stop().removeClass("on");
    state = false;
  });

  $("#gNavi ul li:has(ul)").hover(
    function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this).find(".downBox").addClass("show");
      }
    },
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).find(".downBox").removeClass("show");
      }
    }
  );

  $(".menuBox .sNavi .button").click(function () {
    $(this).toggleClass("on");
    $(this).next().stop().slideToggle(300);
    return false;
  });

  $(".menuBox .sNavi a[href='#']").click(function () {
    $(this).next(".button").toggleClass("on");
    $(this).next(".button").next().stop().slideToggle(300);
    return false;
  });


  if ($(" .comSlide .comList:not(.--typeB)").length) {
    $(".comSlide .comList:not(.--typeB)").slick({
      infinite: true,
      centerMode: false,
      variableWidth: true,
      centerPadding: "0",
      autoplay: true,
      fade: false,
      dots: false,
      arrows: false,
      prevArrow: false,
      nextArrow: false,
    });
  }

  if ($(" .comSlide .comList.--typeB ").length) {
    $(".comSlide .comList.--typeB").slick({
      infinite: false,
      centerMode: false,
      variableWidth: true,
      centerPadding: "0",
      slidesToShow: 3,
      autoplay: false,
      fade: false,
      dots: false,
      arrows: false,
      prevArrow: false,
      nextArrow: false,
    });
  }

  $("#gHeader .hBox .icoUl li").each(function () {
    if ($(this).find(".search").length) {
      var $this = $(this);
      $(this)
        .find("a")
        .click(function () {
          $this.find(".search").fadeToggle();
          return false;
        });
    }
  });
  if ($(".comNumBox").length) {
    $(".comNumBox").each(function () {
      var $this = $(this);
      var addBtn = $(this).find("span:not(.minus)");
      var cutBtn = $(this).find("span.minus");
      var input = $(this).find("input");
      addBtn.on("click", function () {
        var num = $this.find("input").val() ? $this.find("input").val() : 0;
        num = parseInt(num);
        num++;
        input.val(num);
        return false;
      });
      cutBtn.on("click", function () {
        var num = $this.find("input").val() ? $this.find("input").val() : 0;
        num = parseInt(num);
        num--;
        if (num <= 0) {
          num = 0;
        }
        input.val(num);
        return false;
      });
    });
  }
});

$(window).on("load", function () {
  var localLink = window.location + "";
  if (localLink.indexOf("#") != -1 && localLink.slice(-1) != "#") {
    localLink = localLink.slice(localLink.indexOf("#") + 1);
    $("html,body").animate({ scrollTop: $("#" + localLink).offset().top }, 500);
  }
});
